import React, { useCallback, useEffect, useReducer, useState } from "react"
import { atualizarParametros, obterParametros } from "../../../services/parametrosAplicativo"
import useLoadingStore from "../../../stores/LoadingStore"
import { Loading } from "../../RegistradorDePedidos"
import { ParametrosAplicativoInicial } from "../models/parametrosAplicativoModel"
import { ParametrosAplicativoActionsTypes } from "./parametrosAplicativoActions"
import { ParametrosAplicativoContext } from "./ParametrosAplicativoContext"
import { parametrosAplicativoReducer } from "./parametrosAplicativoReducer"

export function ParametrosAplicativoContextProvider({ children }: { children: React.ReactNode }) {
    const [parametros, dispatch] = useReducer(
        parametrosAplicativoReducer,
        ParametrosAplicativoInicial
    )
    const [erroCarregamento, setErroCarregamento] = useState<string | null>(null)
    const setLoading = useLoadingStore(s => s.setLoading)

    const carregar = async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            const response = await obterParametros(autorizacao)
            if ("retornoErro" in response) {
                setErroCarregamento(response.mensagem || "Erro ao carregar parâmetros do aplicativo")
            } else {
                setErroCarregamento(null)
                dispatch({
                    type: ParametrosAplicativoActionsTypes.CARREGAR,
                    payload: {
                        ...ParametrosAplicativoInicial,
                        ...response,
                        podeEditar: response.podeEditar !== false,
                    },
                })
            }
        } catch {
            setErroCarregamento("Erro ao carregar parâmetros do aplicativo")
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        carregar()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const salvar = useCallback(async () => {
        const autorizacao = localStorage.getItem("chaveSistema")
        if (!autorizacao) return
        try {
            setLoading(true)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { podeEditar: _pe, ehClienteFiel: _ecf, ...payload } = parametros
            const response = await atualizarParametros(autorizacao, payload)
            if ("retornoErro" in response) {
                throw new Error(response.mensagem)
            }
            dispatch({
                type: ParametrosAplicativoActionsTypes.CARREGAR,
                payload: {
                    ...ParametrosAplicativoInicial,
                    ...response,
                    podeEditar: response.podeEditar !== false,
                },
            })
        } finally {
            setLoading(false)
        }
    }, [parametros, setLoading])

    return (
        <ParametrosAplicativoContext.Provider
            value={{ parametros, dispatch, salvar, erroCarregamento }}
        >
            <Loading />
            {children}
        </ParametrosAplicativoContext.Provider>
    )
}
